<template>
<div v-if="storeId">
  <div class="tag-selector-trigger">
    <span id="resetValues" @click="resetSelector" v-show="selected.length > 0">
      <b-icon icon="arrow-clockwise"></b-icon>
    </span>
    <b-button v-b-toggle.sidebar-variant :class="{filled: selected.length > 0, unFilled: selected.length == 0}">
      <b-icon icon="tag-fill" style="width: 15px; height: 15px;"></b-icon>
    </b-button>
  </div>

  <b-sidebar id="sidebar-variant" title="Tag Selector" bg-variant="dark" text-variant="light" shadow>
    <div class="px-3 py-2">

      <p>
        Please select tag to assign to the orders
      </p>
      <b-form-select v-model="selected" :options="options" multiple :select-size="4" @change="tagSelectedToAssign"></b-form-select>
      <b-link href="#foo" @click.prevent="resetSelector" class="m-t-5 resetBtn" v-show="selected.length > 0">
        <b-icon icon="arrow-clockwise"></b-icon> Reset
      </b-link>
      <h4 v-if="selected.length > 0" class="m-t-20 m-b-20">Selected Options</h4>
      <b-list-group class="m-t-20">
        <b-list-group-item variant="dark" v-for="(single, index) in selected" :key="index">{{single}}</b-list-group-item>
      </b-list-group>
    </div>
  </b-sidebar>
</div>
</template>

<script>
import OrderTagsService from '../../services/order-tags.service';
import EventBus from '../../EventBus'
export default {
  data() {
    return {
      selected: [], // Array reference
      options: [],
      storeId: null
    }
  },
  mounted() {
    EventBus.$on('store-selected-or-changed', storeId => {
      this.fetchTagsForTheStore(storeId)
    })
  },
  methods: {
    resetSelector() {
      this.selected = [];
      EventBus.$emit('tag-to-be-assigned', this.selected);
    },
    async fetchTagsForTheStore(storeId) {
      this.storeId = storeId;
      const orderTags = await OrderTagsService.fetchOrderTagsByStoreId(storeId)
      this.resetSelector();
      this.options = orderTags.data.tags.map(tag => {
        return {
          text: tag.tag,
          value: tag.tag
        }
      })
    },
    tagSelectedToAssign() {
      console.log(this.selected);
      EventBus.$emit('tag-to-be-assigned', this.selected);
    }
  },
  beforeDestroy() {
    EventBus.$off('store-selected-or-changed')
  }
}
</script>

<style lang="scss" scoped>
.tag-selector-trigger {
  position: fixed;
  right: -3px;
  top: 50%;
  transform: translate(0, -50%);

  button {
    padding: 5px;
    background-color: rgb(255, 81, 0);
    color: #fff;
    border: none;
    border-radius: 4px 0 0 4px;

    &.filled {
      background-color: #6bd425;
    }
  }

  #resetValues {
    position: absolute;
    top: -30px;
    right: 5px;
    cursor: pointer;
  }
}

.resetBtn {
  display: block;
}

.list-group-item-dark {
  background-color: #31364b;
  color: #9fa9d1;
}
</style>
